export default __webpack_public_path__ + "static/media/bid.b8592060.png";